export default __webpack_public_path__ + "d6c18f4679f22510112d795cdd5d537d.svg";